import { render, staticRenderFns } from "./attachments.vue?vue&type=template&id=ec9e335c&scoped=true"
import script from "./attachments.vue?vue&type=script&lang=js"
export * from "./attachments.vue?vue&type=script&lang=js"
import style0 from "./attachments.vue?vue&type=style&index=0&id=ec9e335c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9e335c",
  null
  
)

export default component.exports